<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105" :class="{'yellow': iconColour == 'yellow'}">
        <path d="M52.651,104.489a52.184,52.184,0,1,1,52.184-52.184A52.243,52.243,0,0,1,52.651,104.489Zm0-100.768a48.585,48.585,0,1,0,48.585,48.584A48.637,48.637,0,0,0,52.651,3.721Z"/>
        <path d="M79.717,54.063H24.75a1.8,1.8,0,0,1,0-3.6H79.717a1.8,1.8,0,1,1,0,3.6Z"/>
        <path d="M63.015,71.516a1.751,1.751,0,0,1-1.237-2.988L78.042,52.264,61.778,36a1.749,1.749,0,0,1,2.474-2.474l17.5,17.5a1.749,1.749,0,0,1,0,2.475L64.252,71A1.743,1.743,0,0,1,63.015,71.516Z"/>
    </svg>
</template>

<style lang="scss" scoped>
    path {
        fill: $colour__primary1;

        .yellow & {
            fill: $colour__accent1;
        }
    }
</style>

<script>
export default {
    name: 'ArrowCircleIcon',
    props: ['iconColour']
}
</script>
